import React from "react"
import BasicDataPage from "./basicdata"

export default () => (
  <>
    <BasicDataPage />
  </>
)
